export const MOBILE = 426 + 1;
export const MOBILE_XS = 320 + 1;
